import React from "react";

const CustomLabel = ({ x, y, width, height, value, index, data }) => {
    return (
        <text
            x={x + width / 2 - 35}
            y={height > 0 ? y - 10 : y - 10 + height}
            fill="black"
            textAnchor="middle"
            fontSize={12}
            className=""
        >
            {`$${(value / 1000).toFixed(1).toLocaleString()}`}
        </text>
    );
};

export default CustomLabel;
